import React from 'react';

import TitleAndDescriptionWithOrder from '@components/nycLanding/_shared/titleAndDescriptionWithOrder';
import { NYCLandingType } from '@utils/types/landings';
import ContactForm from '@components/landing/_shared/contactForm';

import styles from './styles.module.scss';

type Props = {
  order: number;
} & NYCLandingType['getStarted'];

const GetStarted = (props: Props) => {
  const { title, description, cta, order } = props;

  return (
    <div className={styles.getStarted}>
      <TitleAndDescriptionWithOrder
        title={title}
        description={description}
        order={order}
      />

      <ContactForm cta={cta} containerStyle={styles.getStarted__form} />
    </div>
  );
};

export default GetStarted;
